import React, { FunctionComponent, useEffect } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Checkbox,
    FormControlLabel,
    Grid,
    TextField,
    Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from '../siu-surveillance-referral-form/SiuSurveillanceReferralForm.Styles';
import ServiceTypeRequestFcmEntity from '../../../../../entities/fcm/ServiceTypeRequestFcm.Entity';

const ADDITIONAL_COMMENTS_MAX = 2500;

export interface IFcmReferralFormProps {
    fcmServiceTypeRequest: ServiceTypeRequestFcmEntity | null;
    onFcmServiceTypeRequestChange: (next: ServiceTypeRequestFcmEntity) => void;
    openCloseStatus?: Record<string, boolean>;
    handleOpenCloseStatus?: (boxName: string, isOpened: boolean) => void;
}

export const FcmReferralForm: FunctionComponent<IFcmReferralFormProps> = (props) => {
    const classes = styles();
    const model = props.fcmServiceTypeRequest ?? ({} as ServiceTypeRequestFcmEntity);

    const setModel = (patch: Partial<ServiceTypeRequestFcmEntity>) => {
        props.onFcmServiceTypeRequestChange({ ...model, ...patch });
    };

    useEffect(() => {
        if (props.handleOpenCloseStatus && props.openCloseStatus && !props.openCloseStatus.hasOwnProperty('FcmSection_box')) {
            props.handleOpenCloseStatus('FcmSection_box', true);
        }
    }, []);

    const handleOpenClose = (event: React.MouseEvent, boxName: string) => {
        event.persist();
        if (props.handleOpenCloseStatus && props.openCloseStatus) {
            props.handleOpenCloseStatus(boxName, !(props.openCloseStatus?.[boxName] ?? true));
        }
    };

    return (
        <Grid item xs={12}>
            <Accordion className={classes.paper} expanded={props.openCloseStatus?.['FcmSection_box'] ?? true}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon className={classes.paperHeaderIcon} />}
                    className={classes.paperHeader}
                    onClick={(event) => handleOpenClose(event, 'FcmSection_box')}
                >
                    <Typography variant="subtitle2" className={classes.sidebarTitle}>
                        Field Case Management
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2} className={classes.gridContainer}>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={!!model.rushRequest}
                                        onChange={(_, checked) => setModel({ rushRequest: checked })}
                                        color="secondary"
                                    />
                                }
                                label="This is a Rush Request"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Additional Comments"
                                multiline
                                minRows={1}
                                fullWidth
                                variant="standard"
                                value={model.additionalInformation ?? ''}
                                onChange={(e) => setModel({ additionalInformation: e.target.value })}
                                inputProps={{ maxLength: ADDITIONAL_COMMENTS_MAX }}
                                helperText={`${(model.additionalInformation ?? '').length}/${ADDITIONAL_COMMENTS_MAX}`}
                                FormHelperTextProps={{ style: { marginTop: 4 } }}
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
};
